import React, { CSSProperties, RefObject } from "react";

import { StyledSpacer, StyledSpacerProps } from "./styles";

interface SpacerProps extends StyledSpacerProps {
  as?: keyof JSX.IntrinsicElements;
  innerRef?: RefObject<any>;
  style?: CSSProperties;
  safePrint?: boolean;
  onClick?: () => void;
}

export const Spacer: React.FC<SpacerProps> = ({
  as,
  spaceDirection = "vertical",
  align = "stretch",
  size = "xs",
  justifyContent = "flex-start",
  flexWrap,
  children,
  innerRef,
  onClick,
  ...rest
}) => (
  <StyledSpacer
    as={as}
    spaceDirection={spaceDirection}
    align={align}
    size={size}
    onClick={onClick}
    justifyContent={justifyContent}
    flexWrap={flexWrap || spaceDirection === "vertical" ? "nowrap" : "wrap"}
    ref={innerRef}
    {...rest}
  >
    {children}
  </StyledSpacer>
);
